// 消息
export default {
    noNews: 'No News',
    TINO: 'There is no more',
    historicalNews: 'Historical News',
    time: 'Time'
}